import React from "react";
import styles from "./form-wrapper.module.scss";
import StepIndicator from "../../../../common/ekedc-components/step-indicator/StepIndicator";
import { BackIcon, CircleCheckmark, CircleQuestionmark } from "../../../../assets/icons";
import QuickGuide from "../../../../common/ekedc-components/quick-guide/QuickGuide";
import { Icons } from "react-toastify";

interface FormWrapperProps {
	children: React.ReactNode;
	onBack?: () => void;
	currentStep: number;
	totalSteps: number;
	showProgress?: boolean;
	showHelp?: boolean;
	title?: string;
	subtitle?: string;
	className?: string;
  isSignUp? : boolean;
	onStepChange?: (step: number) => void;
	onlyPrevious?: boolean;
}

export const FormWrapper: React.FC<FormWrapperProps> = ({
	children,
	onBack,
	currentStep,
	totalSteps,
	showProgress = true,
	showHelp = false,
	title,
	subtitle,
	className,
  isSignUp = false,
	onStepChange,
	onlyPrevious = false,
}) => {
	return (
		<div className={`${styles.formWrapper} ${className ?? ""}`}>
			{showProgress && (
				<div className={styles.progressDiv}>
					<StepIndicator total={totalSteps} current={currentStep - 1} onStepClick={onStepChange ? (index) => onStepChange(index + 1) : undefined} onlyPrevious={onlyPrevious} />
          <QuickGuide icon={
            <div className={styles.iconButton}>
              <CircleQuestionmark />
            </div>
            } title="Information Title" description="Choosing an account type determines how your experience is set up and what features you can access. An individual account is best for personal use, a business account suits teams or companies with higher activity, and an enterprise account supports larger organizations with more advanced needs. Select the option that matches how you plan to use the platform to ensure everything works smoothly from the start." />
        </div>
			)}

			<div className={styles.header}>
				{onBack && !isSignUp && (
					<button type="button" onClick={onBack} className={styles.backButton} aria-label="Go back">
						<BackIcon />
					</button>
				)}
        <div className={styles.titleContainer}>
          {title && <h1 className={styles.headerTitle}>{title}</h1>}
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
			</div>

			<div className={styles.content}>{children}</div>
		</div>
	);
};
